import React, {Component} from 'react';
import {connect} from 'react-redux';
import CloseWindow from './close-window';
import Action from 'actions';

class Popup extends Component {
    onCancel(e) {
        e.preventDefault();
        this.props.dispatch(Action.do('closeModal'));
        this.props.onCancel?.();
    }

    onConfirm(e) {
        e.preventDefault();
        this.props.dispatch(Action.do('closeModal'));
        this.props.onConfirm?.();
    }

    createCancel() {
        const {useCancel = false, cancelText = 'Cancel'} = this.props;

        return useCancel ? (
            <button type="button" onClick={(e) => this.onCancel(e)} className="btn btn-gray">
                {cancelText}
            </button>
        ) : null;
    }

    createConfirm() {
        const {useConfirm = true, confirmText = 'OK'} = this.props;

        return useConfirm ? (
            <button type="button" onClick={(e) => this.onConfirm(e)} autoFocus className="btn">
                {confirmText}
            </button>
        ) : null;
    }

    createClose() {
        const {useClose = false, onClose = null} = this.props;

        return useClose ? (
            <div className="modal-header">
                <CloseWindow onClick={onClose} />
            </div>
        ) : null;
    }

    render() {
        const {children, type, additionalClass} = this.props;

        const className = type === 'details' ? 'modal-details' : 'modal-notification';
        const cancel = this.createCancel();
        const confirm = this.createConfirm();
        const close = this.createClose();

        return (
            <div className={`modal ${additionalClass ? additionalClass : className}`}>
                <div className="modal-content">
                    {close}
                    {children}
                    {(cancel || confirm) && (
                        <div className="modal-actions">
                            {cancel}
                            {confirm}
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

export default connect(() => ({}))(Popup);
